/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const BaseCouponUsageSummaryParser = 
/* #__PURE__ */ parsers.object([
    ['id', codecString],
    ['successAt', parsers.moment, 'success_at'],
]);
export class BaseCouponUsageSummary extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return BaseCouponUsageSummaryParser.decode(input).map(res => new BaseCouponUsageSummary(res));
    }
    static unsafeDecode(input) {
        return BaseCouponUsageSummary.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return BaseCouponUsageSummaryParser.encode(data);
    }
    static schema() {
        return BaseCouponUsageSummaryParser.schema();
    }
}
